import React from "react";
import { SvgIcon } from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon";

const PO28Button13Icon = (props: SvgIconProps) => (
  <SvgIcon fillRule="evenodd" clipRule="evenodd" color="secondary" fontSize="small" {...props}>
    <path d="M3 0H0V15V18H3H18V15H3V0Z" />
  </SvgIcon>
);

export default PO28Button13Icon;
